// extracted by mini-css-extract-plugin
module.exports = {"sofiTopBanner":"lto-top-banner_sofiTopBanner__jGedV"};